import { useState } from 'react';

/**
 * Custom hook for managing step navigation in multi-step components
 * @param {number} totalSteps - Total number of steps in the flow
 * @param {number} initialStep - Initial step to start from (default: 1)
 * @returns {object} Step management functions and current step
 */
export const useStepManager = (totalSteps, initialStep = 1) => {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const goNext = () => {
    setCurrentStep(prev => Math.min(prev + 1, totalSteps));
  };

  const goBack = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const goToStep = step => {
    if (step >= 1 && step <= totalSteps) {
      setCurrentStep(step);
    }
  };

  const reset = () => {
    setCurrentStep(initialStep);
  };

  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return {
    currentStep,
    goNext,
    goBack,
    goToStep,
    reset,
    isFirstStep,
    isLastStep
  };
};
